import Router from "./router";

// Legacy
export * from './shared/utils/hierarchies';

export default Router;
